import {
  LitElement,
  html,
  css,
  map,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js";

export class LookbookTray extends LitElement {
  static properties = {
    _visible: { state: true },
    title: {},
    shopify_video: {},
    image: {},
    products: {},
  };

  static styles = css`
    .look-item__tray {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: #fff;
      z-index: 1000;
      transition-duration: 0.15s;
      transition-property: transform;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transform: translateY(100%);
      overflow-y: auto;
    }

    .look-item__tray--visible {
      transform: translateY(0);
    }

    .tray__header {
      position: sticky;
      top: 0;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 28px;
      background-color: #fff;
      z-index: 2;
    }

    .tray__title {
      color: #000;
      font-family: 'JJannon Display', sans-serif;
      font-size: 47px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;
      padding: 8px 20px 0 0;  
      margin: -8px 0 0;
      overflow: visible !important;  
    }

    .tray__close {
      appearance: none;
      background: none;
      border: none;
      width: 18px;
      height: 18px;
      cursor: pointer;
      padding: 0;
      color: #000;
    }

    img,
    video {
      display: block;
      max-width: 100%;
      object-fit: cover;
    }

    video {
      width: 100%;
      height: auto;
      min-height: 500px;
    }

    .tray__content {
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 3px;
      margin-top: 3px;
      row-gap: 28px;
    }

    .tray__content > lookbook-product {
        width: auto;
        min-width: 0px;
    }

    .desktop-layout.look-item__tray {
      --tray-top-position: 80px;
      top: var(--tray-top-position);
      display: flex;
      overflow: hidden;
    }

    .desktop-layout .tray__content {
      display: block;
      height: 100%;
      min-height: 0;
    }

    .desktop-layout .tray__header {
      padding: 24px 32px;
    }

    .desktop-layout .tray__left {
      height: 0;
      flex: 0 0 570px;
      max-width: 40%;
    }

    .tray__media-container {
      padding-bottom: calc(100vh - var(--tray-top-position));
      position: relative;
    }

    swiper-container {
      --swiper-pagination-bullet-inactive-color: rgba(255, 255, 255, 0.6);
      --swiper-pagination-bullet-inactive-opacity: 0.6;
      --swiper-pagination-bullet-width: 6px;
      --swiper-pagination-bullet-height: 6px;
      --swiper-pagination-bottom: 8px;
      --swiper-pagination-color: #fff;
      align-items: stretch;
    }

    swiper-slide img,
    swiper-slide video {
      height: 100%;
    }

    swiper-slide {
      height: 150vw;
      width: 100vw;
    }

    .desktop-layout swiper-slide {
      height: auto;
      width: auto;
    }

    .desktop-layout .tray__media {
      position: absolute;
      inset: 0;
    }

    .desktop-layout .tray__right {
      display: flex;
      flex-direction: column;
      min-width: 0;
      min-height: 0;
      flex: 1;
    }

    .desktop-layout .tray__title {
      font-size: 60px;
    }

    .desktop-layout video,
    .look-item__desktop-slider img{
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    } 

    .look-item__desktop-slider {
        height: 100%;
        width: 100%;
    }

    .desktop-layout .swiper-container {
      min-height: 0;
      min-width: 0;
      height: 100%;
    }

    .desktop-layout .swiper-slide {
      width: auto;
    }

    .desktop-layout swiper-container::part(button-prev),
    .desktop-layout swiper-container::part(button-next) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 38px;
      height: 38px;
      background-color: #fff;
      border-radius: 50%;
      z-index: 1;
      pointer-events: all;
      color: transparent;
    }

    .desktop-layout swiper-container::part(button-prev)::before {
      transform: rotate(180deg);
    }

    .desktop-layout swiper-container::part(button-prev) {
      left: 30px;
    }

    .desktop-layout swiper-container::part(button-next) {
      right: 30px;
    }

    .desktop-layout swiper-container::part(button-prev) svg,
    .desktop-layout swiper-container::part(button-next) svg {
      display: none !important;
    }

    .desktop-layout swiper-container::part(button-prev)::before,
    .desktop-layout swiper-container::part(button-next)::before {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      width: 21px; /* Adjusted to match SVG width */
      height: 12px; /* Adjusted to match SVG height */
      display: inline-block;
      vertical-align: middle;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none"><path d="M14.7967 1L20 6.09434M14.7967 11L20 6.09434M20 6.09434L-6.99518e-07 6.09434" stroke="black"/></svg>');
      background-size: contain;
      background-repeat: no-repeat;
      border: none; /* Remove border styles */
      margin: -6px 0 0 -10.5px; /* Adjusted to center the SVG */
      transition: all 0.4s;
    }
  `;

  constructor() {
    super();
    this.addEventListener("trayOpenEvent", this._handleTrayOpen);
    this._visible = false;
    this.swiper = null;
  }

  isMobile() {
    return window.innerWidth < 768 || window.innerWidth < window.innerHeight;
  }

  _updateVideoWidth() {
    // Safari issue: video width is not set correctly
    const video = this.shadowRoot.querySelector("video");
    if (video) {
      const videoWidth = video.clientWidth;
      const videoParent = video.parentElement;
      videoParent.style.width = `${videoWidth}px`;
    }
  }

  render() {
    let media;
    if (this.image) {
      media = html`<swiper-slide>
        <img src="${this.image}" alt="${this.title}" />
      </swiper-slide>`;
    }
    if (this.shopify_video) {
      const sources = this.shopify_video.sources.map(
        (source) =>
          html`<source src="${source.url}" type="${source.mime_type}" />`
      );
      media = html`
        ${media}
        <swiper-slide>
          <video
            poster=${this.shopify_video.preview_image.src}
            autoplay
            loop
            muted
            playsinline
            @loadeddata=${this._updateVideoWidth}
          >
            ${sources}
          </video>
        </swiper-slide>
        ${media}
      `;
    } else if (this.video) {
      media = html`
        ${media}
        <swiper-slide>
          <video
            poster=${this.image}
            autoplay
            loop
            muted
            playsinline
            class="product-item__video product-item__media lazyload"
            preload="none"
            @loadeddata=${this._updateVideoWidth}
          >
            <source src="${this.video}" type="video/mp4" />
          </video>
        </swiper-slide>
        ${media}
      `;
    }
    const mobileMarkup = () => {
      let content;
      if (this.products) {
        content = map(this.products, (product) => {
          return html`
            <lookbook-product
              title="${product.title}"
              handle="${product.handle}"
              price="${product.price}"
              image="${product.image}"
            >
            </lookbook-product>
          `;
        });
      }

      return html`
        <div
          class="look-item__tray ${!this.isMobile()
            ? "desktop-layout"
            : ""} ${this._visible ? "look-item__tray--visible" : ""}"
        >
          <div class="tray__header">
            <h3 class="tray__title">${this.title}</h3>
            <button
              class="tray__close"
              @click=${this._handleTrayClose}
              aria-label="Close"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.00007 9.70655L15.6822 16.3785L16.3888 15.6709L9.70772 8.99999L16.3888 2.32906L15.6823 1.62141L9.00007 8.29342L2.3179 1.6214L1.61133 2.32904L8.29242 8.99998L1.61135 15.6709L2.31791 16.3785L9.00007 9.70655Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div class="tray__media">
            <swiper-container
              class="look-item__slider visible-xs-block visually-hidden"
              pagination="true"
            >
              ${media}
            </swiper-container>
          </div>
          <div class="tray__content">${content}</div>
        </div>
      `;
    };

    const desktopMarkup = () => {
      let content;
      if (this.products) {
        content = map(this.products, (product) => {
          return html`
            <swiper-slide class="swiper-slide">
              <lookbook-product
                title="${product.title}"
                handle="${product.handle}"
                price="${product.price}"
                image="${product.image}"
              >
              </lookbook-product>
            </swiper-slide>
          `;
        });

        content = html`
          <swiper-container
            class="swiper-container"
            slides-per-view="auto"
            space-between="2"
            grab-cursor="true"
            navigation="true"
          >
            ${content}
          </swiper-container>
        `;
      }

      return html`
        <div
          class="look-item__tray ${!this.isMobile()
            ? "desktop-layout"
            : ""} ${this._visible ? "look-item__tray--visible" : ""}"
        >
          <div class="tray__left">
            <div class="tray__media-container">
              <div class="tray__media">
                  <swiper-container
                          class="look-item__desktop-slider"
                          pagination="true"
                          pagination-clickable='true'
                  >
                    ${media}
                  </swiper-container>
              </div>
            </div>
          </div>
          <div class="tray__right">
            <div class="tray__header">
              <h3 class="tray__title">${this.title}</h3>
              <button
                class="tray__close"
                @click=${this._handleTrayClose}
                aria-label="Close"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.00007 9.70655L15.6822 16.3785L16.3888 15.6709L9.70772 8.99999L16.3888 2.32906L15.6823 1.62141L9.00007 8.29342L2.3179 1.6214L1.61133 2.32904L8.29242 8.99998L1.61135 15.6709L2.31791 16.3785L9.00007 9.70655Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
            <div class="tray__content">${content}</div>
          </div>
        </div>
      `;
    };

    return this.isMobile() ? mobileMarkup() : desktopMarkup();
  }

  _handleTrayOpen(event) {
    const {
      title,
      video,
      mobile_video,
      shopify_video,
      mobile_shopify_video,
      mobile_image,
      image,
      products,
    } = event.detail;
    this.title = title;
    this.video = this.isMobile() && !!mobile_video ? mobile_video : video;
    this.shopify_video =
      this.isMobile() && !!mobile_shopify_video
        ? mobile_shopify_video
        : shopify_video;
    this.image = this.isMobile() && !!mobile_image ? mobile_image : image;
    this.products = products;
    this._visible = true;
    this._updateSwiperObserver();
    document.body.classList.add("no-scroll");
  }

  _handleTrayClose() {
    this._visible = false;
    this.title = null;
    this.video = null;
    this.shopify_video = null;
    this.image = null;
    this.products = null;
    if (this.swiper) this.swiper.slideTo(0);
    document.body.classList.remove("no-scroll");
  }

  _updateSwiperObserver() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const swiperContainer =
            this.shadowRoot.querySelector("swiper-container");
          if (swiperContainer) {
            const prevButton = swiperContainer.shadowRoot.querySelector(
              'div[part="button-prev"] svg'
            );
            const nextButton = swiperContainer.shadowRoot.querySelector(
              'div[part="button-next"] svg'
            );

            if (prevButton) prevButton.style.display = "none";
            if (nextButton) nextButton.style.display = "none";

            this.swiper = swiperContainer.swiper;

            // Once the swiper-container is found and SVGs are hidden, disconnect the observer
            observer.disconnect();
          }
        }
      }
    });

    // Start observing the shadow DOM for changes
    observer.observe(this.shadowRoot, { childList: true, subtree: true });
  }
}

customElements.define("lookbook-tray", LookbookTray);
